import { REPLACE_ACTIONS } from "@Store/Actions/Action";
export default (state = [], { type, data }) => {
    switch (type) {
        case REPLACE_ACTIONS:
            return data;
    }
    return state;
};
